import { SidebarProvider } from '@/components/ui/sidebar';
import { Toaster } from '@/components/ui/sonner';
import Navbar from '@/Navbar';
import { setUser } from '@sentry/react';
import { PropsWithChildren, useEffect } from 'react';

export default function Guest({ children }: PropsWithChildren) {
  useEffect(() => {
    setUser(null);
  }, []);

  return (
    <SidebarProvider>
      <div className="w-full">
        <Navbar />

        <div className="min-h-screen">{children}</div>

        <Toaster />
      </div>
    </SidebarProvider>
  );
}
